if(document.querySelector(".js-tarifs-table") && tarifsData && Vue) {
    document.querySelectorAll(".js-tarifs-table").forEach($el => {
        const type = $el.getAttribute("data-type")
        new Vue({
            el: $el,
            data() {
                return {
                    loaded: false,
                    sortByType: "",
                    currency: "Kč",
                    tarifs: [
                        {
                            logo: "",
                            name: "",
                            speedDown: 0,
                            speedUp: 0,
                            price: 0,
                        },
                    ]
                }
            },
            computed: {
            },
            methods: {
                sortBy(type) {
                    this.tarifs.sort((a, b) => {
                        const aField = (type == 'speedDown' || type == 'price') ? parseInt(a[type]) : a[type]
                        const bField = (type == 'speedDown' || type == 'price') ? parseInt(b[type]) : b[type]
                        if(aField > bField) return this.sortByType == type ? 1 : -1
                        if(aField < bField) return this.sortByType == type ? -1 : 1
                        return 0;
                      })
                    if(this.sortByType === type)
                        this.sortByType = `${type}-up`
                    else
                        this.sortByType = type
                }
            },
            mounted() {
                this.tarifs = [...tarifsData]
                if(type == "symetric") {
                    this.tarifs = this.tarifs.filter(tarif => tarif.speedDown == tarif.speedUp)
                } else {
                    this.tarifs = this.tarifs.filter(tarif => tarif.speedDown != tarif.speedUp)
                }
                this.sortBy("speedDown")
                this.loaded = true
            }
        })
    })
}